//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: "LoadImgLook",
    components: {
        MyBtnReturn,
    },
    data() {
        return {
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src1: require('@/assets/images/plan/wx_zhuang_blue.png'), // 装箱的图片，右上角的icon
            iconClose: require('@/assets/images/wx_sc_oringe.png'), // 关闭图标
            goBackQuery: {}, // 回退时要带的参数
            displayUrl: '',
            imgSrcList: [
                // require('@/assets/images/plan/wx_zhuang_blue.png'),
                // require('@/assets/images/wx_sc_oringe.png')
            ], // 图片路径列表
            isNoData: false,
            isShowLoading: false,
            step: -1,
        }
    },
    created() {
        document.title = '装货图片';
        let query = this.$route.query;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.id = query.id;
        this.referenceno = query.referenceno;
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype,
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常，原因：页面先被刷新一次，再进入该组件，导致数据丢失，而且用go回退时要两次！
        if (!apiParams.companyId) {
            apiParams.companyId = query.companyId2;
            apiParams.openId = query.openId2;
            this.step = -2
        }
        if (query.type === 'load') {
            this.displayUrl = apiUrl.loadImgDisplay // 装箱图片的接口
        } else if (query.type === 'seal') {
            this.displayUrl = apiUrl.lookSealImg // 封箱图片的接口
        } else {
            this.displayUrl = apiUrl.lookloaddoc; // 装箱单证图片的接口
        }
        this.getDisplayImg()
    },
    methods: {
        getDisplayImg() {
            // 获取可展示的图片
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                ladingId: this.ladingId,
                id: this.id,
                servicetype: this.servicetype,
                referenceno: this.referenceno,
            };
            this.isShowLoading = true;
            this.requestApi({
                url: this.displayUrl,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                let imgSrcList = dataObj.paths || [];
                if (imgSrcList.length === 0) {
                    this.isNoData = true;
                    this.isShowLoading = false;
                    this.imgSrcList = imgSrcList;
                    return
                }
                this.imgSrcList = imgSrcList
                this.$previewRefresh()
            }, (error) => {
                this.isShowLoading = false;
                if (error) {
                    console.error(error);
                }
            })
        },
    },
}



// WEBPACK FOOTER //
// ./src/components/siji/loadImg/LoadImgLook.vue